/**
 * Enumeration of file type identifiers
 */
const FileTypes = {
  SimpleText: "com.saliorel.edu.simpletext",
  PhysicalLink: "com.saliorel.edu.physlink",
  Context: "com.saliorel.edu.context",
  Manuscript: "com.saliorel.edu.manuscript"
};

export default FileTypes;



// WEBPACK FOOTER //
// ./src/modules/editor/FileTypes.js